import { RootState } from 'App'
import { useSelector } from 'react-redux'

export const useTenantId = () => {
  const tenantId = useSelector((state: RootState) => state.user.tenantId)
  return tenantId
}
